<template>
  <div class="bg-box wh100p df-c-ct">

    <div class="fullscreen-box" v-if="isShowFullBtn">
      <div class="themebtn-s" @click="_togglo_full_screen">{{$t('login.toggloFullScreen_'+!!full_screen)}}</div>
    </div>

    <div class="lang-box">
      <el-select class="lang-select" :popper-append-to-body="false" v-model="language" @change="languageChange">
        <el-option v-for="x in languages" :key="x.value" :label="x.label" :value="x.value" />
      </el-select>
    </div>

    <div class="df-l-c-fs">

      <div class="df-l-c-fs mb40">
        <img class="logo" src="@/assets/images/logo-pure-blue.svg" alt="">
        <div class="_themecolor f-xxs mt20">Digitalize your restaurant business</div>
      </div>

      <div class="form-box df-l-c-fs p40">
        <div class="form-tit _themecolor">{{$t('login.login')}}</div>
        <form class="form-con df-l-c-ct">
          <div class="form-item _borderbottom df-c-fs">
            <img class="form-icon _borderright" src="@/assets/icons/loginform-user.svg"/>
            <input
              ref="input1" class="form-input" type="text" :placeholder="$t('login.inputName')"
              v-model="name" autocomplete="off" @focus="onFocus_forScan" @blur="onBlur_forScan" />
          </div>
          <div class="form-item _borderbottom df-c-fs">
            <img class="form-icon _borderright" src="@/assets/icons/loginform-psd.svg"/>
            <input
              ref="input2" class="form-input" type="password" :placeholder="$t('login.inputPsd')"
              v-model="password" autocomplete="off" @focus="onFocus_forScan" @blur="onBlur_forScan" />
          </div>
        </form>
        <div class="themebtn-l" @click="toLogin">{{$t('login.login')}}</div>
        
      </div>

      <div class="footer mt30">
        <div>© 2021 Dola Technology Limited</div>
        <div>Version：{{version}}</div>
      </div>

    </div>

    <el-dialog
      :visible.sync="isShowDialog" :title="title" center width="500px"
      :close-on-click-modal="false" class="dialog" :show-close="false">

      <div class="dialog-con df-l-c-sa">
        <!-- 選擇商鋪 -->
        <template v-if="step==='selectShop'">
          <el-select
            class="shop-select" size="medium"
            :popper-append-to-body="false"
            v-model="shopId">
            <el-option v-for="x in shops" :key="x.id" :label="x['shopName'+_lang]" :value="x.shopId" />
          </el-select>
          <div class="themebtn-l" @click="searchUuid">{{$t('common.comfirm')}}</div>
        </template>
        <!-- 選擇是否开店 -->
        <template v-else-if="step==='selectStatus'">
          <div class="themebtn-l" @click="toggleShopStatus(true)">{{$t('login.inBusiness')}}</div>
          <div class="darkbtn-l" @click="toggleShopStatus(false)">{{$t('login.outBusiness')}}</div>
        </template>
        <!-- 選擇是否售罄 -->
        <template v-else-if="step==='selectSellout'">
          <div class="themebtn-l" @click="clearSellout(true)">{{$t('login.clearSelloutOk')}}</div>
          <div class="whitebtn-l" @click="clearSellout(false)">{{$t('login.clearSelloutNot')}}</div>
        </template>
      </div>

    </el-dialog>

  </div>
</template>

<script>
// 登录流程
// 1 输入账号密码后点击登录，请求登录账号绑定的店铺
// 2 如果店铺数量为1，直接查询有无uuid，无则创建
// 3 将uuid设置在店铺上，然后查询选择店铺是否营业
// 4-1 如果已营业，直接请求店铺数据，获取当前场景，根据场景模式判断首页并进入
// 4-2 如果未营业，弹框询问是否营业，根据选择设置是否营业
// 5-1 如果设置不营业，直接请求店铺数据，获取当前场景，根据场景模式判断首页并进入
// 5-2 如果设置营业，请求查询是否有售罄
// 6-1 如果无售罄，直接请求店铺数据，获取当前场景，根据场景模式判断首页并进入
// 6-1 如果有售罄，弹框询问是否清空售罄
// 7-1 根据选择设置是否清空售罄，然后请求店铺数据，获取当前场景，根据场景模式判断首页并进入
import { mapMutations } from 'vuex'
import mixin_fullScreen from '@/mixins/mixin_fullScreen'
// import { isOperateFun } from '@/utils/timingLock'
export default {
  name: 'login',
  mixins: [mixin_fullScreen],
  data() {
    return {
      language: 'zh',
      languages: [
        { label: '中文繁體', value: 'zh' },
        { label: 'English', value: 'en' },
      ],
      version: '',
      name: '',
      password: '',

      shopId: '',
      shops: [],

      isShowDialog: false,
      step: 'selectShop',
      isShowFullBtn: true,
    }
  },
  computed: {
    title() {
      switch (this.step) {
        case 'selectShop': return this.$t('login.selectShop')
        case 'selectStatus': return this.$t('login.isOpen')
        case 'selectSellout': return this.$t('login.clearSellout')
      }
    }
  },
  methods: {
    ...mapMutations(['user_x_save', 'sceneId_x_save', 'modelList_x_save', 'user_x_clear']),
    // 语言切换
    languageChange(val) {
      this.$i18n.locale = val
      localStorage.setItem('dola_b_language', val)
    },
    // 退出登录
    logout() {
      return this.$api.user_logout().then(res => {
        if (res.status === 0) {
          this.user_x_clear()
        } else { this._status(res) }
      })
    },
    //登陆
    async toLogin() {
      this.el_loading_x_save(true)

      // #region 开启铃声功能
      this.bellOpen_x_save(true)
      // #endregion


      // 先退出登录
      await this.logout()
      // 先判斷是否已经輸入賬號密码
      // 無誤，則登錄
      // 如果賬號类型是超管|商家|經理|服务员，則請求賬號名下商鋪
      let { name, password } = this
      if (!name) {
        this.$message.warning(this.$t('login.inputYourName'))
      } else if (!password) {
        this.$message.warning(this.$t('login.inputYourPsd'))
      } else {
        await this.$api.user_login({
          name,
          password,
          bEndLogin: true
        }).then(async res => {
          if (res.status === 0) {
            let _R1 = res.data
            // console.log('%c用户信息:', 'color: #00f;', _R1)

            // 调⽤Android
            this.$tool.dsbridge_call(this.$tool.dsbridge_map.persistCredentials, { username: name, password })

            // _R1.imgId = '5fffeb66a792c83032af75be.jpg'
            // this.$message.success('登陆成功！')
            const { admin, companyManager, shopManager, waiter, id } = _R1
            if (admin || companyManager || shopManager || waiter) {
            // if (shopManager) {
              this.user_x_save(_R1)
              let _R2 = await this.getData('user2shop', { userId: Number(id) })
              // console.log(`%c用户映射店铺:`, 'color: #00f;', _R2)
              this.shops = _R2
              if (_R2.length) {
                this.shopId = Number(_R2[0].shopId)

                // 判斷店鋪數量
                if (this.shops.length === 1) {
                  this.searchUuid()
                } else {
                  this.step = 'selectShop' // 切換到選擇店鋪
                  this.isShowDialog = true
                }

              } else { this.$message.warning(this.$t('login.notBindShop')) }
            } else { this.$message.warning(this.$t('login.loginWithManagerAccount')) }
          } else { this._status(res) }
        })
      }
      this.el_loading_x_save(false)
    },
    // 查询並創建uuid
    async searchUuid() {
      this.el_loading_x_save(true)
      const UUID = localStorage.getItem('dola_uuid')
      if (!UUID) {
        await this.$api.uuid_create().then(async res => {
          if (res.status == 0) {
            let _R = res.data
            // console.log(`%c新的UUID:`, 'color: #00f;', _R)
            localStorage.setItem('dola_uuid', _R)
            await this.submitUuid(_R)
          } else { this._status(res) }
        })
      } else {
        this.submitUuid(UUID)
      }
      this.el_loading_x_save(false)
    },
    // 設置触摸屏
    async submitUuid(UUID) {
      const _D = await this.newData('monitor', {
        shopId: this.shopId,
        uuid: UUID
      })
      if (_D) {
        this.comfirmShop()
      }
    },
    // 提交
    async comfirmShop() {
      if (this.shopId) {
        // 查询当前店鋪开閉店
        const _R = await this.getData('shop', { id: this.shopId })
        // console.log(`%c当前是否营业:`, 'color: #f0f;', _R[0].businessStatus)
        if (_R.length && _R[0].businessStatus) {
          this.sendAjax_shopStatus(true)
        } else if (_R.length && !_R[0].businessStatus) {
          this.step = 'selectStatus' // 切換到選擇營業状态
          this.isShowDialog = true
        } else {
          this.toggleShopStatus(true)
        }
      }
    },
    // 切換店鋪營業
    async toggleShopStatus(businessStatus) {
      this.el_loading_x_save(true)
      if (businessStatus) {
        // 查询当前商鋪是否有售罄
        await this.$api.sellOut_search({ id: this.shopId }).then(res => {
          if (res.status == 0) {
            let _R = res.data
            // console.log(`%c是否有售罄:`, 'color: #00f;', _R)
            if (_R) {
              // 有售罄
              this.step = 'selectSellout' // 切換到選擇是否售罄
              this.isShowDialog = true
            } else {
              this.sendAjax_shopStatus(true)
            }
          } else { this._status(res) }
        })
      } else {
        // this.sendAjax_shopStatus(false)
        await this.getShopCompanyData(this.shopId)
        this.getWaiters()
        this.getReasonTemp()

        if (this.isShowWaiterModel) {
          this.$router.push(`lock`)
        } else {
          this.getCurrentScene()
        }
      }
      this.el_loading_x_save(false)
    },
    // 清空售罄
    async clearSellout(selloutStatus) {
      this.el_loading_x_save(true)
      if (selloutStatus) {
        await this.$api.sellOut_clear({ id: this.shopId }).then(res => {
          if (res.status == 0) {
            // let _R = res.data
            // console.log(`%c清空售罄结果:`, 'color: #00f;', _R)
            this.sendAjax_shopStatus(true)
          } else { this._status(res) }
        })
      } else {
        this.sendAjax_shopStatus(true)
      }
      this.el_loading_x_save(false)
    },
    async sendAjax_shopStatus(businessStatus) {
      this.$api.shop_status_change({
        shopId: this.shopId,
        businessStatus,
      }).then( async res => {
        if (res.status == 0) {
          await this.getShopCompanyData(this.shopId)
          this.getWaiters()
          this.getReasonTemp()

          if (this.isShowWaiterModel) {
            this.$router.push(`lock`)
          } else {
            this.getCurrentScene()
          }
        } else { this._status(res) }
      })
    },
    // 获取 服务员
    getWaiters() {
      this.$api.waiter_search(this.shop_x.id).then(res => {
        if (res.status == 0) {
          let _R_waiter = res.data
          // console.log(`%c服务员:`, 'color: #f00;', _R_waiter)
          let waiterList = _R_waiter.map(x1 => ({
            id: x1.id,
            nickName: x1.nickName,
          }))
          this.$store.commit('waiters_x_save', waiterList)
        } else { this._status(res) }
      })
    },
    // 获取 预设备注
    async getReasonTemp() {
      const _R = await this.getData('reasonTemp', { shopId: this.shop_x.id })
      // console.log(`%c返回的预设原因:`, 'color: #00f;', _R)
      _R.forEach(x1 => {
        x1.select = false
      })
      this.$store.commit('reasonTemp_x_save', _R)
    },
    // 获取 当前场景
    getCurrentScene() {
      return this.$api.current_scene_search({
          shopId: this.shop_x.id,
        }).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c当前场景:`, 'color: #00f;', _R)
          if (_R) {
            this.sceneId_x_save(_R.id)
            this.modelList_x_save(_R.runModuleSceneList)
            const ITEM_MODEL = _R.runModuleSceneList.find(x => x.type === 0)

            if (ITEM_MODEL && ITEM_MODEL.enable) {
              this.$router.push(`table`)
            } else {
              this.$router.push(`menu?type=fastfood`)
            }
          } else {
            this.sceneId_x_save('')
            this.modelList_x_save([])
            this.$router.push(`menu?type=fastfood`)
          }
            
        } else { this._status(res) }
      })
    },

    // 获取 版本号
    getVersion() {
      this.$api.version_seach().then(({ status, data, msg }) => {
        if (status === 0) {
          // console.log(`%c数据:`, 'color: #f00;', data)
          this.version = data
        } else { ElMessage.error(msg) }
      })
    },

    //绑定键盘事件
    keyupEnter() {
      document.onkeydown = e => {
        if (e.keyCode === 13 && this.$route.path ==='/login') {
          if (!this.name) {
            this.$refs.input1.focus()
          } else if (!this.password) {
            this.$refs.input2.focus()
          } else {
            this.toLogin()
          }
        }
      }
    },
  },
  created() {
    this.getVersion()
    this.keyupEnter()
    this.language = this.lang

    // 登录⻚⾯创建完毕后，判断是否是Android Webview，并获取储存的⽤⼾名、密码
    const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.loadCredentials, '')
    console.log(`%c是否是Android Webview，并获取储存的⽤⼾名、密码:`, 'color: #f00;', RESULT)
    if (RESULT) {
      this.name = RESULT.username
      this.password = RESULT.password
      // 隐藏“切换全屏”按钮
      this.isShowFullBtn = false
    }
  },
}
</script>

<style lang="scss" scoped>
// @import '@/assets/css/element.scss';
/deep/.el-select-dropdown__item{height: 50px;line-height: 50px;}
.bg-box{position: relative;}
// .bg-box{background: url("~assets/images/login-bg.png") no-repeat center center;background-size: 100% 100%;}
.fullscreen-box{
  position: absolute;top: 40px;left: 50px;
}
.lang-box{
  position: absolute;top: 40px;right: 50px;font-size: 20px;
  /deep/.lang-select input{background: transparent;border: none;font-size: 20px;width: 130px;text-align: right;}//color: #333;
  /deep/.lang-select .el-icon-arrow-up{font-size: 20px;}//color: #333;
}
.logo{width: 210px;}
.form-box{
  width: 600px;border: 2px solid #ECEEF4;
  .form-tit{font-size: 36px;}
  .form-con{width: 366px;height: 200px;}
  .form-item{width: 366px;height: 54px;line-height: 54px;margin-top: 16px;}
  .form-icon{width: 24px;height: 24px;padding: 0 12px;}
  .form-input{
    flex: 1;height: 48px;line-height: 48px;border: none;background: transparent;font-size: 20px;margin-left: 12px;
    // text-fill-color: #fff;-webkit-text-fill-color: #fff;
  }
  // .form-input::placeholder{font-size: 20px;}
  .form-input:-webkit-autofill{
    // -webkit-text-fill-color: #fff;
    -webkit-box-shadow: 0 0 0px 1000px #fff  inset !important;
    // -webkit-transition-delay: 99999s;
    // -webkit-transition: all 99999s ease-out;
  }
}
.footer{
  color: #A6A6A6;text-align: center;line-height: 24px;
}

.dialog{
  /deep/.el-dialog__title{font-size: 20px;}
  /deep/.el-dialog__header{padding: 40px 0;}
  /deep/.el-dialog__body{padding: 20px 25px 50px;}
  .shop-select{width: 366px;height: 50px;margin: 30px 0 100px;}
  /deep/input{height: 50px;}
  /deep/.el-icon-arrow-up{font-size: 20px;}
  .dialog-con{height: 230px;}
}
</style>